import * as Adaptive from "adaptivecards";
import { TypedCardElementPeer, PropertySheet, PropertySheetCategory } from "adaptivecards-designer";
import { getPropertyEditorInstance, PropertyKeys } from "../Pickers/PickerBase";
import { removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";

const displayLabelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "displayLabel", true);
const requireFieldProperty = new Adaptive.BoolProperty(Adaptive.Versions.v1_0, "requireField", false);

export class ResolutionDate extends Adaptive.DateInput {
    static readonly JsonTypeName = "Resolution Date";
    static readonly ElementId = "Ticket.ResolutionDate";
    static readonly defaultLabel = "Resolution Date";
    static readonly displayLabelProperty = displayLabelProperty;
    static readonly requireFieldProperty = requireFieldProperty;

    //#region Schema

    @Adaptive.property(displayLabelProperty)
    get displayLabel(): string | undefined {
        return this.getValue(ResolutionDate.displayLabelProperty);
    }

    set displayLabel(value: string | undefined) {
        this.setValue(ResolutionDate.displayLabelProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(requireFieldProperty)
    get requireField(): boolean | undefined {
        return this.getValue(ResolutionDate.requireFieldProperty);
    }

    set requireField(value: boolean | undefined) {
        this.setValue(ResolutionDate.requireFieldProperty, value);
        this.updateLayout();
    }

    //#endregion

    protected internalRender(): HTMLElement | undefined {
        this.id = ResolutionDate.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = ResolutionDate.defaultLabel;

        let textInput = new Adaptive.DateInput();
        textInput.setParent(this);
        textInput.label = this.displayLabel;
        textInput.isRequired = this.requireField;

        if(this.defaultValue)
            textInput.defaultValue = this.defaultValue;

        const renderedElement =  textInput.render();
        this.inputControlContainerElement.style.display = "block";

        return renderedElement;
    }

    getJsonTypeName(): string {
        return ResolutionDate.JsonTypeName;
    }

    updateLayout(processChildren: boolean = true) {
        super.updateLayout(processChildren);
    }
}

export class ResolutionDatePeer extends TypedCardElementPeer<ResolutionDate> {
    static displayLabelProperty = getPropertyEditorInstance(ResolutionDate.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(ResolutionDate.ElementId, PropertyKeys.requireField);
        
    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);
                        
        propertySheet.add(
            defaultCategory,
            ResolutionDatePeer.idProperty,
            ResolutionDatePeer.displayLabelProperty,
            ResolutionDatePeer.requireFieldProperty
        );
    }
}